import React, { Fragment } from "react";
import { Box, Card, LinearProgress, Skeleton, Stack } from "@mui/material";

export const GenericLinearLoader = ({ margin }) => {
  return (
    <LinearProgress
      sx={{
        height: 2,
        margin: margin,
        borderRadius: '10px'
      }}
    />
  );
};

export const FeedLoader = ({ count = 7 }) => {
  return (
    <Fragment>
      {
        Array.from({ length: count }).map((_, index) => {
          return (
            <Box key={`card-key-${index}`}>
              <Card
                sx={{
                  width: '250px',
                  height: '350px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                  <Skeleton variant="circular" width={35} height={35} />
                  <Skeleton variant="rounded" sx={{ borderRadius: '20px' }} width={110} height={35} />
                </Stack>
                <Box>
                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={1}>
                    <Skeleton variant="text" sx={{ fontSize: '1.7rem', width: 100 }} />
                    <Skeleton variant="rounded" width={35} />
                  </Stack>
                  <Skeleton variant="text" sx={{ fontSize: '1rem', width: 150 }} />
                  <Stack mt={0.5} direction={'row'} gap={1.5} justifyContent={'space-between'}>
                    {
                      Array.from({ length: 3 }).map((_, index) => {
                        return (
                          <Stack key={`social-key-${index}`} direction={'row'} alignItems={'center'} gap={0.5}>
                            <Skeleton variant="circular" width={20} height={20} />
                            <Skeleton variant="text" sx={{ fontSize: '1.2rem', width: 30 }} />
                          </Stack>
                        );
                      })
                    }
                  </Stack>
                </Box>
              </Card>
            </Box>
          );
        })
      }
    </Fragment>
  );
};